import React, { useState } from 'react';
import { useUser } from '../../context/UserContext';
import { authPpiApiAxiosWithRefresh } from '../../services/api';
import { Card, Button, Row, Col, Statistic, Typography, message } from 'antd';
import './CreditDashboard.scss';

const { Title } = Typography;

const CreditDashboard = () => {
  const { credits, user } = useUser();
  const [loading, setLoading] = useState<string | null>(null);

  // 2. Buy Function
  const buyCredits = async (packageId: any) => {
    if (!user) return;
    
    setLoading(packageId);

    try {
      const response = await (await authPpiApiAxiosWithRefresh()).post(`/create-checkout-session`, { packageId }, {
            headers: {
              'Content-Type': 'application/json',
          },
      });

      const { url } = response.data;
      if (url) {
        window.location.href = url;
      }
    } catch (error) {
      message.error('Failed to create checkout session. Please try again.');
    } finally {
      setLoading(null);
    }
  };

  return (
    <div className="credit-dashboard">
      <Row justify="center" align="middle" style={{ marginBottom: '2rem' }}>
        <Col>
          <Statistic title="Your Balance" value={credits} suffix="Credits" />
        </Col>
      </Row>

      <Title level={3} style={{ textAlign: 'center', marginBottom: '2rem' }}>
        Purchase Credits
      </Title>

      <Row gutter={[16, 16]} justify="center">
        <Col xs={24} sm={12} md={8}>
          <Card title="Small Pack" className="pricing-card">
            <p>10 Credits</p>
            <Title level={4}>$10</Title>
             <Button type="primary" onClick={() => buyCredits('pack_small')} loading={loading === 'pack_small'}>
              Buy Small
            </Button>
          </Card>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Card title="Medium Pack" className="pricing-card">
            <p>25 Credits</p>
            <Title level={4}>$20 (Save $5)</Title>
            <Button type="primary" onClick={() => buyCredits('pack_medium')} loading={loading === 'pack_medium'}>
              Buy Medium
            </Button>
          </Card>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Card title="Large Pack" className="pricing-card">
            <p>50 Credits</p>
            <Title level={4}>$40 (Save $10)</Title>
            <Button type="primary" onClick={() => buyCredits('pack_large')} loading={loading === 'pack_large'}>
              Buy Large
            </Button>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default CreditDashboard;